"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _generalStore = require("general-store");

var _ETypes = _interopRequireDefault(require("crm_universal/timeline/ETypes"));

var _immutable = require("immutable");

var _TimelineCard = _interopRequireDefault(require("crm_ui/timeline/components/generic/TimelineCard"));

var _TimelineMonthLabel = _interopRequireDefault(require("crm_ui/timeline/components/generic/TimelineMonthLabel"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _UIColumn = _interopRequireDefault(require("UIComponents/column/UIColumn"));

var _UIColumnWrapper = _interopRequireDefault(require("UIComponents/column/UIColumnWrapper"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _TimelineTeamsFilterDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineTeamsFilterDependency"));

var _TimelineUsersFilterDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineUsersFilterDependency"));

var _TimelineTextFilterDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineTextFilterDependency"));

var _EngagementsStore = _interopRequireDefault(require("crm_data/engagements/EngagementsStore"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _EngagementRecord = _interopRequireDefault(require("customer-data-objects/engagement/EngagementRecord"));

var _TimelineFilterEngagementTypes = require("crm_ui/timeline/helpers/TimelineFilterEngagementTypes");

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _EventTypeRedesignMap = _interopRequireDefault(require("crm_ui/config/EventTypeRedesignMap"));

var _TimelineEventHelpers = require("crm_ui/timeline/helpers/TimelineEventHelpers");

var TimelinePinnedEngagement =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TimelinePinnedEngagement, _PureComponent);

  function TimelinePinnedEngagement() {
    (0, _classCallCheck2.default)(this, TimelinePinnedEngagement);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelinePinnedEngagement).apply(this, arguments));
  }

  (0, _createClass2.default)(TimelinePinnedEngagement, [{
    key: "shouldRenderPinnedEngagement",
    value: function shouldRenderPinnedEngagement() {
      var _this$props = this.props,
          filteredEventTypes = _this$props.filteredEventTypes,
          pinnedEngagement = _this$props.pinnedEngagement,
          selectedTeams = _this$props.selectedTeams,
          selectedUsers = _this$props.selectedUsers,
          searchText = _this$props.searchText;

      if (!pinnedEngagement) {
        return false;
      }

      if (filteredEventTypes) {
        var engagementType = pinnedEngagement.getIn(['engagement', 'type']);
        var isFilteringByPinnedEngagementType = filteredEventTypes.some(function (filterType) {
          return _TimelineFilterEngagementTypes.ENGAGEMENT_FILTER_TYPE_TO_ENGAGEMENT_TYPES.get(filterType).contains(engagementType);
        });

        if (!isFilteringByPinnedEngagementType) {
          return false;
        }
      }

      var teamId = pinnedEngagement.getIn(['engagement', 'teamId'], '');
      var createdBy = pinnedEngagement.getIn(['engagement', 'createdBy'], '');
      var body = pinnedEngagement.getIn(['metadata', 'body'], '');

      if (selectedTeams.size && !selectedTeams.includes("" + teamId)) {
        return false;
      }

      if (selectedUsers.size && !selectedUsers.includes("" + createdBy)) {
        return false;
      }

      if (searchText.length && body.indexOf(searchText) === -1) {
        return false;
      }

      return true;
    }
  }, {
    key: "renderPinnedEngagement",
    value: function renderPinnedEngagement() {
      var _this$props2 = this.props,
          subject = _this$props2.subject,
          pinnedEngagement = _this$props2.pinnedEngagement,
          objectType = _this$props2.objectType;
      var engagement = pinnedEngagement;
      var timelineItem = (0, _immutable.Map)({
        etype: _ETypes.default.eventEngagement,
        id: engagement.getIn(['engagement', 'id']),
        timestamp: engagement.getIn(['engagement', 'timestamp']),
        eventData: engagement
      });
      return _react.default.createElement(_TimelineCard.default, {
        isPinned: true,
        objectType: objectType,
        subjectId: "" + (0, _ImmutableModel.getId)(subject),
        timelineItem: timelineItem,
        TimelineEvent: (0, _TimelineEventHelpers.getViewType)(_EventTypeRedesignMap.default, timelineItem),
        subject: subject
      });
    }
  }, {
    key: "renderSectionTitle",
    value: function renderSectionTitle() {
      return _react.default.createElement(_UIColumnWrapper.default, {
        className: "m-bottom-2",
        "data-selenium-test": "timeline-pinned-engagement-title"
      }, _react.default.createElement(_UIColumn.default, null, _react.default.createElement(_TimelineMonthLabel.default, {
        className: "m-bottom-0 m-top-4"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "pinnedSection.title"
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.shouldRenderPinnedEngagement()) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "p-bottom-0"
      }, this.renderSectionTitle(), this.renderPinnedEngagement());
    }
  }]);
  return TimelinePinnedEngagement;
}(_PureComponent2.default);

var dependencyProps = {
  objectType: _ObjectTypesType.default.isRequired
};
TimelinePinnedEngagement.propTypes = (0, _extends2.default)({
  filteredEventTypes: _reactImmutableProptypes.default.list,
  pinnedEngagement: _propTypes.default.instanceOf(_EngagementRecord.default),
  subject: _SubjectType.default.isRequired
}, dependencyProps);
var dependencies = {
  pinnedEngagement: {
    stores: [_EngagementsStore.default],
    propTypes: {
      pinnedEngagementId: _propTypes.default.number
    },
    deref: function deref(_ref) {
      var pinnedEngagementId = _ref.pinnedEngagementId;

      if (!pinnedEngagementId) {
        return null;
      }

      return _EngagementsStore.default.get(pinnedEngagementId);
    }
  },
  selectedTeams: _TimelineTeamsFilterDependency.default,
  selectedUsers: _TimelineUsersFilterDependency.default,
  searchText: _TimelineTextFilterDependency.default
};

var _default = (0, _generalStore.connect)(dependencies)(TimelinePinnedEngagement);

exports.default = _default;
module.exports = exports.default;